import {createAsyncThunk} from '@reduxjs/toolkit'
import {config} from 'src/config'
import {RootState} from '../index'
import {NO_ERROR_MESSAGE} from '../handler'
import type {CallbackType} from './entities'
import {closeModal, hideModal} from './slice'

export const hideModalThunk = createAsyncThunk<void, CallbackType, { rejectValue: string; state: RootState }>(
  'modal/hideModalThunk',
  async (handleClose, thunkAPI) => {
    try {
      thunkAPI.dispatch(hideModal())
      setTimeout(async () => {
        thunkAPI.dispatch(closeModal())
        await handleClose?.()
      }, config.modalCloseAnimationTime)
    } catch (error) {
      if (error instanceof Error) {
        return thunkAPI.rejectWithValue(error.message)
      }
      return thunkAPI.rejectWithValue(NO_ERROR_MESSAGE)
    }
  }
)
